import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useTermsStore from 'stores/terms/terms.store';

const useTermOfAdhesion = () => {
  const {
    terms,
    loading,
    filterStatus,
    setFilterStatus,
    filterCity,
    setFilterCity,
  } = useTermsStore();

  const navigate = useNavigate();
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [sortBy, setSortBy] = useState<string | null>(null);
  const [orderBy, setOrderBy] = useState<string | null>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [page, setPage] = useState(1);
  const [take] = useState(10);
  const [totalCount] = useState(0);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectTerm = (id: string) => {
    let updatedSelectedUsers = [...selectedUsers];

    if (updatedSelectedUsers.includes(id)) {
      updatedSelectedUsers = updatedSelectedUsers.filter(
        (userId) => userId !== id,
      );
    } else {
      updatedSelectedUsers.push(id);
    }

    setSelectedUsers(updatedSelectedUsers);
    setSelectAllChecked(updatedSelectedUsers.length === terms.length);
  };

  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      setSelectedUsers(terms.map((term) => term.uuid));
      setSelectAllChecked(true);
    } else {
      setSelectedUsers([]);
      setSelectAllChecked(false);
    }
  };

  const handleSelect = (uuid: string) => {
    setSelectedUsers((prevSelected) =>
      prevSelected.includes(uuid)
        ? prevSelected.filter((id) => id !== uuid)
        : [...prevSelected, uuid],
    );
  };

  const handleDownloadSelected = () => {
    selectedUsers.forEach((uuid) => {
      const term = terms.find((t) => t.uuid === uuid);
      if (term?.fileId?.base64) {
        const link = document.createElement('a');
        link.href = term.fileId.base64;
        link.download = term.fileId.name || 'termo_de_adesao.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  };

  const handleDownloadTerm = (term: any) => {
    if (term.fileId?.base64) {
      const link = document.createElement('a');
      link.href = `data:application/pdf;base64,${term.fileId.base64}`;
      link.download = term.fileId.name || 'termo_adesao.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.error('Arquivo não disponível para download.');
    }
  };

  const handleClearFilters = () => {
    setFilterStatus('');
    setFilterCity('');
    setTimeout(() => { }, 300);
  };

  return {
    navigate,
    selectedUsers,
    selectAllChecked,
    terms,
    loading,
    filterStatus,
    filterCity,
    sortBy,
    handleSelectTerm,
    handleSelectAll,
    handleSelect,
    handleDownloadSelected,
    handleDownloadTerm,
    anchorEl,
    open,
    handleClick,
    handleClose,
    take,
    page,
    setPage,
    totalCount,
    setFilterStatus,
    setFilterCity,
    setSortBy,
    setOrderBy,
    handleClearFilters,
  };
};

export default useTermOfAdhesion;
